import classNames from 'clsx';
import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import CloseButton from '@swf/components/StarsModal/components/CloseButton';
import type { Dispatch } from '@swf/core/store';

import type { HGToastType } from '../../types/common';

import styles from './ToastMessage.scss';

interface ToastMessageProps {
  dataTestIid?: string;
  id: keyof typeof HGToastType;
  isHidden?: boolean;
}

const ToastMessage: React.FC<React.PropsWithChildren<ToastMessageProps>> = ({
  children,
  dataTestIid = 'toast-container',
  id,
  isHidden = false
}) => {
  const animationDelay = 500;
  const [isHideBanner, setIsHideBanner] = useState(isHidden);
  const { localSettings } = useDispatch<Dispatch>();

  const handleOnCloseClicked = useCallback(() => {
    setIsHideBanner(true);
    setTimeout(() => {
      localSettings.set({
        homegames: { toastMessage: { [id]: { isHidden: true } } }
      });
    }, animationDelay);
  }, [localSettings, id]);

  return (
    <div className={styles.toastContainer} data-testid={dataTestIid}>
      <div className={classNames(styles.toastMessage, { [styles.hideBanner]: isHideBanner })}>
        {children}
        <CloseButton className={styles.closeButton} onClick={handleOnCloseClicked} />
      </div>
    </div>
  );
};

export default ToastMessage;
